export const JsonData = [
  {
    id: 6885,
    field_id: "tags",
    field_name: "Tags",
    field_tooltip: "",
    control_type: "TAG_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 1,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 0,
    db_column: "tags",
    maxlength: 0,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [], // No dropdown values for tag input
  },

  {
    id: 1988,
    field_id: "name",
    field_name: "name",
    field_tooltip: "",
    control_type: "TEXTAREA",
    override_control_size: "col s12 l6",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 5,
    required: 1,
    db_column: "name",
    maxlength: 40000,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 1975,
    field_id: "description",
    field_name: "Description",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "ip",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "Section details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 6880,
    field_id: "department",
    field_name: "Department",
    field_tooltip: "",
    control_type: "SELECT2",
    override_control_size: "col s12 m6 l3",
    override_control_class: "select2ajax",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "department",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [
      { key: "INFOSEC", value: "INFOSEC1" },
      { key: "ADMIN", value: "ADMIN" },
      { key: "HR", value: "HR" },
    ],
  },
  {
    id: 6881,
    field_id: "department_1",
    field_name: "Department_1",
    field_tooltip: "",
    control_type: "MULTIPLE SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "department_1",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [
      { key: "INFOSEC", value: "INFOSEC1" },
      { key: "ADMIN", value: "ADMIN" },
      { key: "HR", value: "HR" },
    ],
  },
  {
    id: 6882,
    field_id: "is_billable",
    field_name: "Is Billable",
    field_tooltip: "",
    control_type: "RADIO",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "is_billable",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [
      { key: "Yes", value: "Yes" },
      { key: "No", value: "No" },
    ],
  },
  {
    id: 6883,
    field_id: "hobbies",
    field_name: "Hobbies",
    field_tooltip: "",
    control_type: "CHECKBOX",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "hobbies",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [
      { key: "Yes", value: "Yes" },
      { key: "No", value: "No" },
    ],
  },
  {
    id: 6884,
    field_id: "file_upload",
    field_name: "File Upload",
    field_tooltip: "",
    control_type: "FILE",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 1, // 1 for single file upload, specify a value > 1 for multiple file upload
    read_only: 0,
    visible: 1,
    list_id: "",
    default_value: "", // Provide any default value if needed
    sqn_no: 1,
    required: 1, // Set to 1 if the file upload is required
    db_column: "file_upload",
    maxlength: 0, // Max length of the file name or 0 if not limited
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [],
  },
];

const TableData = [
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name: "Azure_Agent",
    Owner: "",
    "Reservation Id": "r-07c024df90793aeda",
    Location: "ap-south-1a",
    "Instance Type": "t2.medium",
    Status: "running",
    "Operating System": "Linux/UNIX",
    "Public IP": "13.232.145.122",
    "Public DNS": "ec2-13-232-145-122.ap-south-1.compute.amazonaws.com",
    "Private Id": "172.31.39.6",
    "Private DNS": "ip-172-31-39-6.ap-south-1.compute.internal",
    "Subnet Id": "subnet-c02b01a8",
    "VCP Id": "vpc-76cec31e",
    Architecture: "x86_64",
    "Tag Keys": "Name",
    "Tag Values": "Azure_Agent",
    "Security Group Names": "Azure_agent_SG",
    "Security Group Ids": "sg-0635b9f8c3e50d21d",
    "Storage Device Names": "/dev/sda1",
    "Storage Attach Times": "11/07/2023 14:44:05",
    "Storage Attach Status": "attached",
    "Storage Volume id": "vol-0256fd77e02e92712",
    "Creation Date": "11/27/2023 12:26:40",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "D05FDB8E-8CA1-454E-B9BA-2B91B2FF6823",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name: "SecureNexus ASM",
    Owner: "",
    "Reservation Id": "r-0d3dfb6c0c36cff98",
    Location: "ap-south-1a",
    "Instance Type": "c5.xlarge",
    Status: "running",
    "Operating System": "Linux/UNIX",
    "Public IP": "13.232.179.45",
    "Public DNS": "ec2-13-232-179-45.ap-south-1.compute.amazonaws.com",
    "Private Id": "10.0.4.186",
    "Private DNS": "ip-10-0-4-186.ap-south-1.compute.internal",
    "Subnet Id": "subnet-03238e7f9a28eaa33",
    "VCP Id": "vpc-0d061daae596e7f3c",
    Architecture: "x86_64",
    "Tag Keys": "Name",
    "Tag Values": "SecureNexus ASM",
    "Security Group Names": "SecureNexus-SG",
    "Security Group Ids": "sg-07f37947a808f6d24",
    "Storage Device Names": "/dev/sda1",
    "Storage Attach Times": "09/03/2023 16:22:51",
    "Storage Attach Status": "attached",
    "Storage Volume id": "vol-0d5236a13a9376c57",
    "Creation Date": "10/11/2023 19:43:01",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "F78F5348-BFE8-49A0-8663-95F14AB84B82",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name: "SecureNexus SCA",
    Owner: "",
    "Reservation Id": "r-08a24fe9e835c19dd",
    Location: "ap-south-1a",
    "Instance Type": "t2.large",
    Status: "running",
    "Operating System": "Linux/UNIX",
    "Public IP": "52.66.129.62",
    "Public DNS": "ec2-52-66-129-62.ap-south-1.compute.amazonaws.com",
    "Private Id": "10.0.12.116",
    "Private DNS": "ip-10-0-12-116.ap-south-1.compute.internal",
    "Subnet Id": "subnet-03238e7f9a28eaa33",
    "VCP Id": "vpc-0d061daae596e7f3c",
    Architecture: "x86_64",
    "Tag Keys": "Name",
    "Tag Values": "SecureNexus SCA",
    "Security Group Names": "SecureNexus-SG",
    "Security Group Ids": "sg-07f37947a808f6d24",
    "Storage Device Names": "/dev/sda1",
    "Storage Attach Times": "06/29/2023 08:42:44",
    "Storage Attach Status": "attached",
    "Storage Volume id": "vol-06034582f66d6c090",
    "Creation Date": "09/14/2023 16:55:59",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "67ACE9AF-E700-4999-A5F6-6FDDF5832EE1",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name: "SecureNexus DB",
    Owner: "",
    "Reservation Id": "r-02342fa529f8ca5ec",
    Location: "ap-south-1a",
    "Instance Type": "t2.medium",
    Status: "running",
    "Operating System": "Linux/UNIX",
    "Public IP": "13.233.86.213",
    "Public DNS": "ec2-13-233-86-213.ap-south-1.compute.amazonaws.com",
    "Private Id": "172.31.35.81",
    "Private DNS": "ip-172-31-35-81.ap-south-1.compute.internal",
    "Subnet Id": "subnet-c02b01a8",
    "VCP Id": "vpc-76cec31e",
    Architecture: "x86_64",
    "Tag Keys": "Name",
    "Tag Values": "SecureNexus DB",
    "Security Group Names": "launch-wizard-16",
    "Security Group Ids": "sg-01245b78f3f5b52fd",
    "Storage Device Names": "/dev/sda1",
    "Storage Attach Times": "03/06/2023 21:32:55",
    "Storage Attach Status": "attached",
    "Storage Volume id": "vol-08b27134212eda0d4",
    "Creation Date": "03/06/2023 21:32:54",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "55059266-3B0C-4501-8E08-B5AE88724E81",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name: "asm",
    Owner: "",
    "Reservation Id": "r-01ced2d24d1d9724a",
    Location: "ap-south-1a",
    "Instance Type": "t2.large",
    Status: "running",
    "Operating System": "Linux/UNIX",
    "Public IP": "3.6.96.192",
    "Public DNS": "ec2-3-6-96-192.ap-south-1.compute.amazonaws.com",
    "Private Id": "172.31.38.60",
    "Private DNS": "ip-172-31-38-60.ap-south-1.compute.internal",
    "Subnet Id": "subnet-c02b01a8",
    "VCP Id": "vpc-76cec31e",
    Architecture: "x86_64",
    "Tag Keys": "Name",
    "Tag Values": "asm",
    "Security Group Names": "ec2-rds-1, launch-wizard-15",
    "Security Group Ids": "sg-0f3ec9ce9a87745b8, sg-057f5e7dc9a40e1d9",
    "Storage Device Names": "/dev/sda1",
    "Storage Attach Times": "12/27/2022 12:28:09",
    "Storage Attach Status": "attached",
    "Storage Volume id": "vol-003adfee17f376f41",
    "Creation Date": "12/23/2023 10:43:03",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "4614B6B0-4FF6-484B-95CD-D8CC79E01755",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name: "vkyc auditor",
    Owner: "",
    "Reservation Id": "r-08d99c52395cc054b",
    Location: "ap-south-1b",
    "Instance Type": "t2.small",
    Status: "running",
    "Operating System": "Linux/UNIX",
    "Public IP": "13.233.158.73",
    "Public DNS": "ec2-13-233-158-73.ap-south-1.compute.amazonaws.com",
    "Private Id": "172.31.11.229",
    "Private DNS": "ip-172-31-11-229.ap-south-1.compute.internal",
    "Subnet Id": "subnet-602cb42c",
    "VCP Id": "vpc-76cec31e",
    Architecture: "x86_64",
    "Tag Keys": "Name",
    "Tag Values": "vkyc auditor",
    "Security Group Names": "launch-wizard-9",
    "Security Group Ids": "sg-0233c591e8854019d",
    "Storage Device Names": "/dev/sda1",
    "Storage Attach Times": "03/04/2022 17:19:47",
    "Storage Attach Status": "attached",
    "Storage Volume id": "vol-00fbc8c4f6da3435c",
    "Creation Date": "04/11/2023 10:07:50",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "D44B2EAE-5D2C-425B-BAF2-1DDE50642DE4",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name: "outline",
    Owner: "",
    "Reservation Id": "r-0cdcf2749adaf85bf",
    Location: "ap-south-1a",
    "Instance Type": "t2.micro",
    Status: "running",
    "Operating System": "Linux/UNIX",
    "Public IP": "3.7.173.13",
    "Public DNS": "ec2-3-7-173-13.ap-south-1.compute.amazonaws.com",
    "Private Id": "172.31.42.92",
    "Private DNS": "ip-172-31-42-92.ap-south-1.compute.internal",
    "Subnet Id": "subnet-c02b01a8",
    "VCP Id": "vpc-76cec31e",
    Architecture: "x86_64",
    "Tag Keys": "Name",
    "Tag Values": "outline",
    "Security Group Names": "launch-wizard-12",
    "Security Group Ids": "sg-0ed2a1bc2df261cee",
    "Storage Device Names": "/dev/sda1",
    "Storage Attach Times": "04/07/2022 00:20:31",
    "Storage Attach Status": "attached",
    "Storage Volume id": "vol-0c6cb58c13d81ca92",
    "Creation Date": "07/27/2023 14:36:20",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "F25022AB-0557-4A41-982E-20384746C1F5",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name: "videokyc",
    Owner: "",
    "Reservation Id": "r-0f18051c258bf33a9",
    Location: "ap-south-1b",
    "Instance Type": "t2.medium",
    Status: "running",
    "Operating System": "Linux/UNIX",
    "Public IP": "13.232.200.149",
    "Public DNS": "ec2-13-232-200-149.ap-south-1.compute.amazonaws.com",
    "Private Id": "172.31.3.218",
    "Private DNS": "ip-172-31-3-218.ap-south-1.compute.internal",
    "Subnet Id": "subnet-602cb42c",
    "VCP Id": "vpc-76cec31e",
    Architecture: "x86_64",
    "Tag Keys": "videokyc, Name",
    "Tag Values": "agent assisted, videokyc",
    "Security Group Names": "launch-wizard-8",
    "Security Group Ids": "sg-01ef30f4a369591f0",
    "Storage Device Names": "/dev/sda1",
    "Storage Attach Times": "02/08/2022 22:05:27",
    "Storage Attach Status": "attached",
    "Storage Volume id": "vol-0b3064de0493f8101",
    "Creation Date": "04/11/2023 10:08:33",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "11964208-1990-4A0E-AFDD-D37866DACA82",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name: "Kali Linux",
    Owner: "",
    "Reservation Id": "r-0c0561d3e05711f9d",
    Location: "ap-south-1b",
    "Instance Type": "t2.medium",
    Status: "pending",
    "Operating System": "Linux/UNIX",
    "Public IP": "3.7.116.59",
    "Public DNS": "ec2-3-7-116-59.ap-south-1.compute.amazonaws.com",
    "Private Id": "172.31.9.178",
    "Private DNS": "ip-172-31-9-178.ap-south-1.compute.internal",
    "Subnet Id": "subnet-602cb42c",
    "VCP Id": "vpc-76cec31e",
    Architecture: "x86_64",
    "Tag Keys": "Name",
    "Tag Values": "Kali Linux",
    "Security Group Names": "Kali Linux-Kali Linux 2021-3-AutogenByAWSMP-",
    "Security Group Ids": "sg-0ca61afb13b080eac",
    "Storage Device Names": "/dev/sda1",
    "Storage Attach Times": "09/28/2021 22:46:11",
    "Storage Attach Status": "attaching",
    "Storage Volume id": "vol-08bc906102681b3ab",
    "Creation Date": "12/27/2023 10:00:44",
  },
];
const VulnerabilityTableData = [
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Key:'jequery:jequery',
    "CVE Value": "CVE-208-1286",
    Assigner: 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Key:'jequery:jequery',
    "CVE Value": "CVE-208-1286",
    Assigner: 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Key:'jequery:jequery',
    "CVE Value": "CVE-208-1286",
    Assigner: 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Key:'jequery:jequery',
    "CVE Value": "CVE-208-1286",
    Assigner: 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Key:'jequery:jequery',
    "CVE Value": "CVE-208-1286",
    Assigner: 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  
];
const ScanDetailData = [
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    'Scan Id':'jequery:jequery',
    "Packages Discovered": "com.xbiz.Neo",
    "Issues found": 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Key:'jequery:jequery',
    "CVE Value": "CVE-208-1286",
    Assigner: 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Key:'jequery:jequery',
    "CVE Value": "CVE-208-1286",
    Assigner: 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Key:'jequery:jequery',
    "CVE Value": "CVE-208-1286",
    Assigner: 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Key:'jequery:jequery',
    "CVE Value": "CVE-208-1286",
    Assigner: 'security@pache.org',
    'Affected Assets': 100,
    "Published Date": '02/09/2020',
    "Last Modified Date": '02/09/2020',
    Description:'This Academic free license v3.',
    References:'NA',
    CWE:'CWE-610',
    "CVSS 2":"AV:N/AC:L/Au:N/C:P/I:N?A:N",
  },
  
];

const AddFormData = [
  {
    id: 1989,
    field_id: "name",
    field_name: "Name",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "name",
    maxlength: 500,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: true,
    section_name: "Virtual Machine details 1",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1990,
    field_id: "owner",
    field_name: "Owner",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 2,
    required: 0,
    db_column: "owner",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1991,
    field_id: "reservationid",
    field_name: "Reservation Id",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 3,
    required: 0,
    db_column: "reservationId",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1992,
    field_id: "location",
    field_name: "Location",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 4,
    required: 0,
    db_column: "location",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1993,
    field_id: "instancetype",
    field_name: "Instance Type",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 5,
    required: 0,
    db_column: "instanceType",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1994,
    field_id: "status",
    field_name: "Status",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 6,
    required: 0,
    db_column: "status",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1995,
    field_id: "operatingsystem",
    field_name: "Operating System",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 7,
    required: 0,
    db_column: "operatingsystem",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1996,
    field_id: "publicip",
    field_name: "Public IP",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 8,
    required: 0,
    db_column: "publicip",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1997,
    field_id: "publicdns",
    field_name: "Public DNS",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 9,
    required: 0,
    db_column: "publicdns",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1998,
    field_id: "privateip",
    field_name: "Private IP",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 10,
    required: 0,
    db_column: "privateid",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 1999,
    field_id: "privatedns",
    field_name: "Private DNS",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 11,
    required: 0,
    db_column: "privatedns",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2000,
    field_id: "subnetid",
    field_name: "Subnet Id",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 12,
    required: 0,
    db_column: "subnetId",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2001,
    field_id: "vpcid",
    field_name: "VPC Id",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 13,
    required: 0,
    db_column: "vcpid",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2002,
    field_id: "architecture",
    field_name: "Architecture",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 14,
    required: 0,
    db_column: "architecture",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2003,
    field_id: "tagkeys",
    field_name: "Tag Keys",
    field_tooltip: "",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 15,
    required: 0,
    db_column: "tagkeys",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2004,
    field_id: "tagvalues",
    field_name: "Tag Values",
    field_tooltip: "",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 16,
    required: 0,
    db_column: "tagvalues",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2005,
    field_id: "securitygroupnames",
    field_name: "Security Group Names",
    field_tooltip: "",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    override_control_size: "col s12 l6",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 17,
    required: 0,
    db_column: "securitygroupnames",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: true,
    section_name: "Security Group Details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2006,
    field_id: "securitygroupids",
    field_name: "Security Group Ids",
    field_tooltip: "",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    override_control_size: "col s12 l6",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 18,
    required: 0,
    db_column: "securitygroupids",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2007,
    field_id: "storagedevicenames",
    field_name: "Storage Device Names",
    field_tooltip: "",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    override_control_size: "col s12 l6",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 19,
    required: 0,
    db_column: "storgedevicenames",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: true,
    section_name: "Storage Details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2008,
    field_id: "storageattachtimes",
    field_name: "Storage Attach Times",
    field_tooltip: "",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    override_control_size: "col s12 l6",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 20,
    required: 0,
    db_column: "storageattachtimes",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2009,
    field_id: "storageattachstatus",
    field_name: "Storage Attach Status",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 21,
    required: 0,
    db_column: "storageattachstatus",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2010,
    field_id: "storagevolumeid",
    field_name: "Storage Volume id",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 22,
    required: 0,
    db_column: "storagevolumeid",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
  {
    id: 2011,
    field_id: "creationdate",
    field_name: "Creation Date",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 23,
    required: 0,
    db_column: "creationdate",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    application_number: "",
  },
];

export const editResponse = [
  {
    value_id: 159749,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "name",
    control_value_1: "Azure_Agent",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Name",
    control_type: "TEXT_INPUT",
    sqn_no: 1,
    questionitems: "",
    control_value: "Azure_Agent",
  },
  {
    value_id: 159750,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "reservationid",
    control_value_1: "r-07c024df90793aeda",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Reservation Id",
    control_type: "TEXT_INPUT",
    sqn_no: 3,
    questionitems: "",
    control_value: "r-07c024df90793aeda",
  },
  {
    value_id: 159751,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "location",
    control_value_1: "ap-south-1a",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Location",
    control_type: "TEXT_INPUT",
    sqn_no: 4,
    questionitems: "",
    control_value: "ap-south-1a",
  },
  {
    value_id: 159752,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "instancetype",
    control_value_1: "t2.medium",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Instance Type",
    control_type: "TEXT_INPUT",
    sqn_no: 5,
    questionitems: "",
    control_value: "t2.medium",
  },
  {
    value_id: 159754,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "status",
    control_value_1: "running",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Status",
    control_type: "TEXT_INPUT",
    sqn_no: 6,
    questionitems: "",
    control_value: "running",
  },
  {
    value_id: 159755,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "operatingsystem",
    control_value_1: "Linux/UNIX",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Operating System",
    control_type: "TEXT_INPUT",
    sqn_no: 7,
    questionitems: "",
    control_value: "Linux/UNIX",
  },
  {
    value_id: 159756,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "publicip",
    control_value_1: "13.232.145.122",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Public IP",
    control_type: "TEXT_INPUT",
    sqn_no: 8,
    questionitems: "",
    control_value: "13.232.145.122",
  },
  {
    value_id: 159757,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "publicdns",
    control_value_1: "ec2-13-232-145-122.ap-south-1.compute.amazonaws.com",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Public DNS",
    control_type: "TEXT_INPUT",
    sqn_no: 9,
    questionitems: "",
    control_value: "ec2-13-232-145-122.ap-south-1.compute.amazonaws.com",
  },
  {
    value_id: 159758,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "privateip",
    control_value_1: "172.31.39.6",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Private IP",
    control_type: "TEXT_INPUT",
    sqn_no: 10,
    questionitems: "",
    control_value: "172.31.39.6",
  },
  {
    value_id: 159759,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "privatedns",
    control_value_1: "ip-172-31-39-6.ap-south-1.compute.internal",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Private DNS",
    control_type: "TEXT_INPUT",
    sqn_no: 11,
    questionitems: "",
    control_value: "ip-172-31-39-6.ap-south-1.compute.internal",
  },
  {
    value_id: 159760,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "subnetid",
    control_value_1: "subnet-c02b01a8",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Subnet Id",
    control_type: "TEXT_INPUT",
    sqn_no: 12,
    questionitems: "",
    control_value: "subnet-c02b01a8",
  },
  {
    value_id: 159761,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "vpcid",
    control_value_1: "vpc-76cec31e",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "VPC Id",
    control_type: "TEXT_INPUT",
    sqn_no: 13,
    questionitems: "",
    control_value: "vpc-76cec31e",
  },
  {
    value_id: 159762,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "architecture",
    control_value_1: "x86_64",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Architecture",
    control_type: "TEXT_INPUT",
    sqn_no: 14,
    questionitems: "",
    control_value: "x86_64",
  },
  {
    value_id: 159763,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "tagkeys",
    control_value_1: "Name",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Tag Keys",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    sqn_no: 15,
    questionitems: "",
    control_value: "Name",
  },
  {
    value_id: 159764,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "tagvalues",
    control_value_1: "Azure_Agent",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Tag Values",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    sqn_no: 16,
    questionitems: "",
    control_value: "Azure_Agent",
  },
  {
    value_id: 159765,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "securitygroupnames",
    control_value_1: "Azure_agent_SG",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Security Group Names",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    sqn_no: 17,
    questionitems: "",
    control_value: "Azure_agent_SG",
  },
  {
    value_id: 159766,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "securitygroupids",
    control_value_1: "sg-0635b9f8c3e50d21d",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Security Group Ids",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    sqn_no: 18,
    questionitems: "",
    control_value: "sg-0635b9f8c3e50d21d",
  },
  {
    value_id: 159767,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "storagedevicenames",
    control_value_1: "/dev/sda1",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Storage Device Names",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    sqn_no: 19,
    questionitems: "",
    control_value: "/dev/sda1",
  },
  {
    value_id: 159768,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "storageattachtimes",
    control_value_1: "11/07/2023 14:44:05",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Storage Attach Times",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    sqn_no: 20,
    questionitems: "",
    control_value: "11/07/2023 14:44:05",
  },
  {
    value_id: 159769,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "storageattachstatus",
    control_value_1: "attached",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Storage Attach Status",
    control_type: "TEXT_INPUT",
    sqn_no: 21,
    questionitems: "",
    control_value: "attached",
  },
  {
    value_id: 159770,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "storagevolumeid",
    control_value_1: "vol-0256fd77e02e92712",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Storage Volume id",
    control_type: "TEXT_INPUT",
    sqn_no: 22,
    questionitems: "",
    control_value: "vol-0256fd77e02e92712",
  },
  {
    value_id: 159753,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "creationdate",
    control_value_1: "11/27/2023 12:26:40",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "Creation Date",
    control_type: "TEXT_INPUT",
    sqn_no: 23,
    questionitems: "",
    control_value: "11/27/2023 12:26:40",
  },
  {
    value_id: 159771,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "moduleid",
    control_value_1: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "",
    control_type: "",
    sqn_no: "",
    questionitems: "",
    control_value: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
  },
  {
    value_id: 159772,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "txnid",
    control_value_1: "2250E3B4-9530-462B-A951-3163A0690301",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "",
    control_type: "",
    sqn_no: "",
    questionitems: "",
    control_value: "2250E3B4-9530-462B-A951-3163A0690301",
  },
  {
    value_id: 159773,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "hash_value",
    control_value_1:
      "f894e27cc2f6c0ec48c6ebbcbf5a0a1962b4d71c952f209f25572c145652a366",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "",
    control_type: "",
    sqn_no: "",
    questionitems: "",
    control_value:
      "f894e27cc2f6c0ec48c6ebbcbf5a0a1962b4d71c952f209f25572c145652a366",
  },
  {
    value_id: 159774,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "createdat",
    control_value_1: "2023-12-27 13:49:48.162285",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "",
    control_type: "",
    sqn_no: "",
    questionitems: "",
    control_value: "2023-12-27 13:49:48.162285",
  },
  {
    value_id: 159775,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "modifiedat",
    control_value_1: "2023-12-27 13:49:48.162289",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "",
    control_type: "",
    sqn_no: "",
    questionitems: "",
    control_value: "2023-12-27 13:49:48.162289",
  },
  {
    value_id: 159776,
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    field_id: "isvisible",
    control_value_1: 1,
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    group_id: "",
    flag: 1,
    created_date: "27-12-2023 13:49:47",
    created_by: "",
    last_modified_date: "27-12-2023 13:49:47",
    last_modified_by: "",
    field_name: "",
    control_type: "",
    sqn_no: "",
    questionitems: "",
    control_value: 1,
  },
];

export const allFieldDataJson = [
  {
    id: 1,
    field_id: "Title",
    field_name: "Title",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "Title",
    maxlength: 500,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: true,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 2,
    field_id: "Description",
    field_name: "Description",
    field_tooltip: "",
    control_type: "TEXTAREA",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 2,
    required: 0,
    db_column: "Description",
    maxlength: 1000,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 3,
    field_id: "Age",
    field_name: "Age",
    field_tooltip: "",
    control_type: "NUMBER",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 3,
    required: 0,
    db_column: "Age",
    maxlength: 1000,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 4,
    field_id: "DOB",
    field_name: "DOB",
    field_tooltip: "",
    control_type: "DATE_PICKER",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 4,
    required: 0,
    db_column: "DOB",
    maxlength: "",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 5,
    field_id: "DOB_Time",
    field_name: "DOB_Time",
    field_tooltip: "",
    control_type: "TIME_PICKER",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 5,
    required: 0,
    db_column: "DOB_Time",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 6,
    field_id: "Birth_Certificate",
    field_name: "Birth Certificate",
    field_tooltip: "",
    control_type: "DRAG_AND_DROP",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 6,
    required: 0,
    db_column: "Birth_Certificate",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 7,
    field_id: "Hobbies",
    field_name: "Hobbies",
    field_tooltip: "",
    control_type: "MULTIPLE_SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 7,
    required: 0,
    db_column: "Hobbies",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [
      {
        id: "HHBHSI678675",
        value: "Cooking",
      },
      {
        id: "BHJHKN67870",
        value: "Reading Books",
      },
    ],
  },
  {
    id: 8,
    field_id: "Id_Proof",
    field_name: "Identity Proof",
    field_tooltip: "",
    control_type: "FILE",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 8,
    required: 0,
    db_column: "Id_Proof",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 9,
    field_id: "About",
    field_name: "About",
    field_tooltip: "",
    control_type: "WYSIWYG",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 9,
    required: 0,
    db_column: "About",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 10,
    field_id: "Experiences",
    field_name: "Experiences",
    field_tooltip: "",
    control_type: "WYSIWYG_SHORT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 10,
    required: 0,
    db_column: "Experiences",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "short_WYSIWYG",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 11,
    field_id: "Domains_knowledge",
    field_name: "Which Domains knowledge you have",
    field_tooltip: "",
    control_type: "AUTOCOMPLETE_WITH_CHIPS",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 11,
    required: 0,
    db_column: "Domains_knowledge",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 12,
    field_id: "Address_Income_Proof",
    field_name: "Address/Income Proof",
    field_tooltip: "",
    control_type: "MULTIPLE_FILE_WITH_ADD_REMOVE",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 12,
    required: 0,
    db_column: "Address_Income_Proof",
    maxlength: "",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 13,
    field_id: "Gender",
    field_name: "Gender",
    field_tooltip: "",
    control_type: "RADIO",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 13,
    required: 0,
    db_column: "Gender",
    maxlength: "",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    optionvalues: [
      {
        id: "BHOJJCSCS787778",
        value: "MALE",
      },
      {
        id: "HBHBJGVH65687",
        value: "FEMALE",
      },
    ],
  },
  {
    id: 14,
    field_id: "Preference",
    field_name: "Preference",
    field_tooltip: "",
    control_type: "CHECKBOX",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 14,
    required: 0,
    db_column: "Preference",
    maxlength: "",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    optionvalues: [
      {
        id: "GBBJHBJ6556151",
        value: "Google",
      },
      {
        id: "HGVGJHBJHB5551125",
        value: "Microsoft",
      },
      {
        id: "GHHJBHJK86495123",
        value: "Amazon",
      },
    ],
  },
  {
    id: 15,
    field_id: "Designation",
    field_name: "Designation",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 15,
    required: 0,
    db_column: "Designation",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    optionvalues: [
      {
        id: "HJJKDJK5465615",
        value: "Senior Software developer",
      },
      {
        id: "BHJHJKHUHJ65511545",
        value: "Backend Developer",
      },
    ],
  },
];
export const applicationInfoFormData = [
  {
    id: 1,
    field_id: "os",
    field_name: "OS",
    field_tooltip: "",
    control_type: "RADIO",
    override_control_size: "col s12 m12 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 13,
    required: 0,
    db_column: "OS",
    maxlength: "",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: false,
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    optionvalues: [
      {
        id: "IOS",
        value: "IOS",
      },
      {
        id: "ANDRIOD",
        value: "ANDRIOD",
      },
    ],
  },
  {
    id: 2,
    field_id: "app_id",
    field_name: "App ID",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "ip",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "Section details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 3,
    field_id: "app_version",
    field_name: "App Version",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "department_1",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [
      { key: "VERSION1", value: "VERSION1" },
      { key: "VERSION2", value: "VERSION2" },
      { key: "VERSION3", value: "VERSION3" },
    ],
  },
  {
    id: 4,
    field_id: "free",
    field_name: "Free",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "department_1",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [
      { key: "FREE 1", value: "FREE 1" },
      { key: "FREE 2", value: "FREE 2" },
      { key: "FREE 3", value: "FREE 3" },
    ],
  },
  {
    id: 5,
    field_id: "app_icon",
    field_name: "App Icon",
    field_tooltip: "",
    control_type: "FILE",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 1, // 1 for single file upload, specify a value > 1 for multiple file upload
    read_only: 0,
    visible: 1,
    list_id: "",
    default_value: "", // Provide any default value if needed
    sqn_no: 1,
    required: 1, // Set to 1 if the file upload is required
    db_column: "file_upload",
    maxlength: 0, // Max length of the file name or 0 if not limited
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [],
  },
  {
    id: 6,
    field_id: "currency",
    field_name: "Currency",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "department_1",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [{ key: "INR", value: "INR" }],
  },
  {
    id: 7,
    field_id: "title",
    field_name: "Title",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "ip",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "Section details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 8,
    field_id: "summary",
    field_name: "Summary",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "ip",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "Section details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 9,
    field_id: "category",
    field_name: "Category",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "department_1",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "IP Reputation Details",
    event_1: "onchange",
    event_2: "",
    event_3: "",
    func_1: "test(1)",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    dropdownvalues: [
      { key: "CATEGORY1", value: "CATEGORY1" },
      { key: "CATEGORY2", value: "CATEGORY2" },
      { key: "CATEGORY3", value: "CATEGORY3" },
    ],
  },
  {
    id: 10,
    field_id: "updated_on",
    field_name: "Updated On",
    field_tooltip: "",
    control_type: "DATE_PICKER",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: null,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 4,
    required: 0,
    db_column: "DOB",
    maxlength: "",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "",
    is_section: "",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 11,
    field_id: "price",
    field_name: "Price",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "ip",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "Section details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 12,
    field_id: "price_text",
    field_name: "Price Text",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "ip",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "Section details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 13,
    field_id: "score",
    field_name: "Score",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "ip",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "Section details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
  {
    id: 14,
    field_id: "score_text",
    field_name: "Score Text",
    field_tooltip: "",
    control_type: "TEXT_INPUT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: 2,
    read_only: 0,
    visible: 1,
    list_id: "",
    deafult_value: "",
    sqn_no: 1,
    required: 1,
    db_column: "ip",
    maxlength: 200,
    expression_txt: "",
    sub_list_id: "",
    moduleid: "0E889228-8A98-11EE-BA96-0265362DF3C0",
    is_section: true,
    section_name: "Section details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
  },
];
export const formWidthSection = [
  {
    id: "329",
    field_id: "audittype",
    field_name: "Audit",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6",
    override_control_class: "",
    file_length: "2",
    read_only: "0",
    visible: "1",
    list_id: "C4DDE842-5367-42BD-991C-C698CEAD4790",
    deafult_value: "",
    sqn_no: "1",
    required: "1",
    db_column: "AuditType",
    maxlength: "4000",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "true",
    section_name: "Finding Details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "TBLVM_AUDITTRACKER",
    lookup_fk: "TXNID",
    lookup_column: "AUDITTYPE",
    DropdownValues:
      '[{"Key":"5A31DD07-B285-4048-9F78-EDCB13366C0B","Value":"Digi Prop (Red Team Assessment)"},{"Key":"FD5CE9DF-6E21-4487-A237-D02A2EC37C8E","Value":"Digi Vision1 (Vulnerability Assessment)"},{"Key":"F9F9854A-5E8D-414D-98D7-A80B0F306182","Value":"Mobile (Source Code Review)"},{"Key":"D6CDA578-C36B-4BFD-959A-D76990AA5A06","Value":"Valid SIS (Vulnerability Assessment)"},{"Key":"EDB91B4C-A0B4-4BA9-89CA-F2D68246443E","Value":"Digi Vision1 (Red Team Assessment)"},{"Key":"B9294495-16CF-47A2-81EF-5044AFE45C73","Value":"DataPrime01 (Vulnerability Assessment)"},{"Key":"B45D36FF-BE7C-4347-8F44-5372B678C6B1","Value":"DataPrime01 (Red Team Assessment)"},{"Key":"F08A86E6-497F-4514-9D42-067F13734168","Value":""}]',
  },
  {
    id: "330",
    field_id: "priority",
    field_name: "Priority",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: "2",
    read_only: "0",
    visible: "1",
    list_id: "DC04E5B5-13AC-488B-84E9-0EC6957DB32A",
    deafult_value: "",
    sqn_no: "2",
    required: "0",
    db_column: "Priority",
    maxlength: "500",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "false",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "TBL_DROPDOWNITEM",
    lookup_fk: "TXNID",
    lookup_column: "NAME",
    DropdownValues:
      '[{"Key":"4C1DC6A5-B9A1-4666-A1FA-678988838334","Value":"High"},{"Key":"307C3201-9EA4-41B9-AEAF-5D1EEB1C6417","Value":"Medium"},{"Key":"58F1BD2D-3C4F-4EC9-96F2-BDC5DD04E429","Value":"Low"}]',
  },
  {
    id: "331",
    field_id: "title",
    field_name: "Title",
    field_tooltip: "",
    control_type: "TEXTAREA",
    override_control_size: "col s12 l6",
    override_control_class: "",
    file_length: "2",
    read_only: "0",
    visible: "1",
    list_id: "",
    deafult_value: "",
    sqn_no: "3",
    required: "1",
    db_column: "Title",
    maxlength: "4000",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "true",
    section_name: "Issue Details",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    DropdownValues: null,
  },
  {
    id: "332",
    field_id: "vulnerabilitylist",
    field_name: "Vulnerability List",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: "2",
    read_only: "0",
    visible: "1",
    list_id: "04AB1A7E-EB77-4306-A37E-495B79004B29",
    deafult_value: "",
    sqn_no: "4",
    required: "1",
    db_column: "VulnerabilityList",
    maxlength: "4000",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "false",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "TBLVM_VULNERABILITYLIST",
    lookup_fk: "TXNID",
    lookup_column: "TITLE",
    DropdownValues:
      '[{"Key":"AC04B844-CEFC-11EE-A376-02C7682B2D6D","Value":"Broken Access Control"},{"Key":"AC04C30C-CEFC-11EE-A384-02C7682B2D6D","Value":"Broken Authentication"},{"Key":"AC04B79A-CEFC-11EE-A374-02C7682B2D6D","Value":"Broken Authentication and Session Management"},{"Key":"AC04BA88-CEFC-11EE-A37E-02C7682B2D6D","Value":"Broken Cryptography"},{"Key":"AC04B970-CEFC-11EE-A37A-02C7682B2D6D","Value":"Clickjacking"},{"Key":"AC04B74A-CEFC-11EE-A373-02C7682B2D6D","Value":"Cross-Site Request Forgery (CSRF)"},{"Key":"AC04C3DE-CEFC-11EE-A388-02C7682B2D6D","Value":"Cross-Site Script Inclusion (XSSI)"},{"Key":"AC04AEBC-CEFC-11EE-A371-02C7682B2D6D","Value":"Cross-Site Scripting (XSS)"},{"Key":"AC04BA56-CEFC-11EE-A37D-02C7682B2D6D","Value":"Improper Error Handling"},{"Key":"AC04C406-CEFC-11EE-A389-02C7682B2D6D","Value":"Information Leakage"},{"Key":"AC04C294-CEFC-11EE-A382-02C7682B2D6D","Value":"Insecure Communications"},{"Key":"AC04B9C0-CEFC-11EE-A37B-02C7682B2D6D","Value":"Insecure Cryptographic Storage"},{"Key":"AC04B894-CEFC-11EE-A377-02C7682B2D6D","Value":"Insecure Direct Object Reference (IDOR)"},{"Key":"AC04C348-CEFC-11EE-A385-02C7682B2D6D","Value":"Insecure Direct Object References"},{"Key":"AC04C51E-CEFC-11EE-A38C-02C7682B2D6D","Value":"Insecure File Uploads"},{"Key":"AC04BA10-CEFC-11EE-A37C-02C7682B2D6D","Value":"Insufficient Authorization"},{"Key":"AC04C550-CEFC-11EE-A38D-02C7682B2D6D","Value":"Insufficient Cryptography"},{"Key":"AC04C3AC-CEFC-11EE-A387-02C7682B2D6D","Value":"Insufficient Defenses Against Buffer Overflow"},{"Key":"AC04C230-CEFC-11EE-A380-02C7682B2D6D","Value":"Insufficient Input Validation"},{"Key":"AC04B8DA-CEFC-11EE-A378-02C7682B2D6D","Value":"Insufficient Logging and Monitoring"},{"Key":"AC04C438-CEFC-11EE-A38A-02C7682B2D6D","Value":"Insufficient Session Expiration"},{"Key":"AC04B920-CEFC-11EE-A379-02C7682B2D6D","Value":"Remote Code Execution (RCE)"},{"Key":"AC04C4EC-CEFC-11EE-A38B-02C7682B2D6D","Value":"Security Misconfiguration"},{"Key":"AC04C1E0-CEFC-11EE-A37F-02C7682B2D6D","Value":"Security Misconfiguration"},{"Key":"AC04C37A-CEFC-11EE-A386-02C7682B2D6D","Value":"Server-Side Request Forgery (SSRF)"},{"Key":"AC04C262-CEFC-11EE-A381-02C7682B2D6D","Value":"Session Fixation"},{"Key":"AC04B68C-CEFC-11EE-A372-02C7682B2D6D","Value":"SQL Injection (SQLi)"},{"Key":"AC04C2C6-CEFC-11EE-A383-02C7682B2D6D","Value":"XML External Entity (XXE)"},{"Key":"AC04B7FE-CEFC-11EE-A375-02C7682B2D6D","Value":"XML External Entity (XXE) Injection"}]',
  },
  {
    id: "999",
    field_id: "type",
    field_name: "Type",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: "2",
    read_only: "0",
    visible: "1",
    list_id: "2FDCAC66-89BA-4301-943B-AFEA671FDB4E",
    deafult_value: "",
    sqn_no: "4",
    required: "1",
    db_column: "Type",
    maxlength: "500",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "false",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "TBL_DROPDOWNITEM",
    lookup_fk: "TXNID",
    lookup_column: "NAME",
    DropdownValues:
      '[{"Key":"F8A83A74-BDD4-4ED6-BEAE-637F925FD30F","Value":"New"},{"Key":"AB63C9E0-37AD-430D-AC35-BA6CF3BCB130","Value":"Re-raised"}]',
  },
  {
    id: "333",
    field_id: "severity_type",
    field_name: "Severity",
    field_tooltip: "",
    control_type: "RADIO",
    override_control_size: "col s12",
    override_control_class: "",
    file_length: "2",
    read_only: "0",
    visible: "1",
    list_id: "50139AFE-5673-439B-825F-AE2830322F11",
    deafult_value: "",
    sqn_no: "5",
    required: "1",
    db_column: "Severity_Type",
    maxlength: "500",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "false",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    DropdownValues: null,
  },
  {
    id: "334",
    field_id: "severitystatus",
    field_name: "Severity Status",
    field_tooltip: "",
    control_type: "SELECT",
    override_control_size: "col s12 m6 l3",
    override_control_class: "",
    file_length: "2",
    read_only: "1",
    visible: "1",
    list_id: "F6BD7A02-B2D3-418C-B22E-336BB5435788",
    deafult_value: "",
    sqn_no: "6",
    required: "1",
    db_column: "SeverityStatus",
    maxlength: "4000",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "false",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "TBL_DROPDOWNITEM",
    lookup_fk: "TXNID",
    lookup_column: "NAME",
    DropdownValues:
      '[{"Key":"638BD707-9BDC-4AE5-8A98-867B33A211DC","Value":"Critical"},{"Key":"CB9BDCB5-4BDA-4261-8692-655C82F45108","Value":"High"},{"Key":"ECDE89B8-CFD4-4D28-B583-866821C5551D","Value":"Medium"},{"Key":"B057D56D-6B0F-4EED-9407-F55F46894688","Value":"Low"},{"Key":"3CE2783B-38F2-4FE2-AC7F-C20E5194C0D4","Value":"Info"}]',
  },
  {
    id: "336",
    field_id: "description",
    field_name: "Description",
    field_tooltip: "",
    control_type: "WYSIWYG",
    override_control_size: "col s12",
    override_control_class: "",
    file_length: "2",
    read_only: "0",
    visible: "1",
    list_id: "",
    deafult_value: "",
    sqn_no: "7",
    required: "1",
    db_column: "Description",
    maxlength: "4000",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "false",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    DropdownValues: null,
  },
  {
    id: "335",
    field_id: "affectedurl",
    field_name: "Affected URL",
    field_tooltip: "",
    control_type: "TEXTAREA",
    override_control_size: "col s12 l6",
    override_control_class: "",
    file_length: "2",
    read_only: "0",
    visible: "1",
    list_id: "",
    deafult_value: "",
    sqn_no: "8",
    required: "0",
    db_column: "AffectedURL",
    maxlength: "4000",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "false",
    section_name: "",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    DropdownValues: null,
  },
  {
    id: "337",
    field_id: "docid",
    field_name: "DocID",
    field_tooltip: "",
    control_type: "MULTIPLE_FILE_WITH_ADD_REMOVE",
    override_control_size: "col s12 m6 l3",
    override_control_class: "type-doc type-img",
    file_length: "2",
    read_only: "0",
    visible: "1",
    list_id: "",
    deafult_value: "",
    sqn_no: "9",
    required: "0",
    db_column: "DocID",
    maxlength: "4000",
    expression_txt: "",
    sub_list_id: "",
    moduleid: "4B2A9ECE-5571-11EB-A5F8-2B9D3754AA92",
    is_section: "true",
    section_name: "Upload Files",
    event_1: "",
    event_2: "",
    event_3: "",
    func_1: "",
    func_2: "",
    func_3: "",
    lookup_table: "",
    lookup_fk: "",
    lookup_column: "",
    DropdownValues: null,
  },
];
const LicenseTableData = [
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name:'This Academic free license v3.',
    "License ID": "AFL -3.0",
    "IS FSFLibre": 'True',
    "Is OSI Approved":'False',
    "Is Deprecated License Id":'True',
    "Deprecated Version":'com.xbiz.Neo',
    Permissions:'com.xbiz.Neo',
    Conditions:'com.xbiz.Neo',
    Limitations:'com.xbiz.Neo',
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name:'This Academic free license v3.',
    "License ID": "AFL -3.0",
    "IS FSFLibre": 'True',
    "Is OSI Approved":'False',
    "Is Deprecated License Id":'True',
    "Deprecated Version":'com.xbiz.Neo',
    Permissions:'com.xbiz.Neo',
    Conditions:'com.xbiz.Neo',
    Limitations:'com.xbiz.Neo',
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name:'This Academic free license v3.',
    "License ID": "AFL -3.0",
    "IS FSFLibre": 'True',
    "Is OSI Approved":'False',
    "Is Deprecated License Id":'True',
    "Deprecated Version":'com.xbiz.Neo',
    Permissions:'com.xbiz.Neo',
    Conditions:'com.xbiz.Neo',
    Limitations:'com.xbiz.Neo',
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name:'This Academic free license v3.',
    "License ID": "AFL -3.0",
    "IS FSFLibre": 'True',
    "Is OSI Approved":'False',
    "Is Deprecated License Id":'True',
    "Deprecated Version":'com.xbiz.Neo',
    Permissions:'com.xbiz.Neo',
    Conditions:'com.xbiz.Neo',
    Limitations:'com.xbiz.Neo',
  },
  {
    module_no: "7B44C9B8-A0BE-11EE-9A99-0265362DF3C0",
    txn_no: "2250E3B4-9530-462B-A951-3163A0690301",
    contextmenujson: [
      {
        menuid: "8E76CE35-0834-46E1-95B4-C586C93C3AD7",
        title: "Edit",
        icon: "edit",
        url: null,
        functionname: "Edit",
        sequence: 2,
      },
      {
        menuid: "459B3756-2684-49F8-88E2-F9DF2915B1A2",
        title: "Delete",
        icon: "delete",
        url: null,
        functionname: "Delete",
        sequence: 3,
      },
    ],
    Name:'This Academic free license v3.',
    "License ID": "AFL -3.0",
    "IS FSFLibre": 'True',
    "Is OSI Approved":'False',
    "Is Deprecated License Id":'True',
    "Deprecated Version":'com.xbiz.Neo',
    Permissions:'com.xbiz.Neo',
    Conditions:'com.xbiz.Neo',
    Limitations:'com.xbiz.Neo',
  },
  
];
const data = { JsonData, TableData, VulnerabilityTableData, ScanDetailData,LicenseTableData, AddFormData, applicationInfoFormData, formWidthSection };

export default data;
// export default JsonData;
